/** @jsx jsx */
/**
 * This file contains all global components for MDX files
 */
import { jsx, Styled } from "theme-ui"
import { MdxLink } from "gatsby-theme-i18n"
import { Col, Container, Row } from "components/layout"
import { Blue, ExtraLarge, Large, Medium, Small } from "components/type"
import Panel from "components/panel"

const StyledMdxLink = props => <Styled.a as={MdxLink} {...props} />

export default {
  Col,
  Container,
  Row,
  Blue,
  ExtraLarge,
  Large,
  Medium,
  Small,
  Panel,
  a: StyledMdxLink,
}
